export default __webpack_public_path__ + "static/media/Social Verbal Learner.d149744f.png";